import React from 'react';
import Header from '../components/Header';
import './MainPage.css';

const MainPage = () => {
  const noticeUrl = '/notice';

  return (
    <div className="main-page-container">
      <Header showControls={false} title="my SKKU" />
      
      <main className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">
            성균관대학교<br />
            <span className="highlight">학생 생활의 모든 것</span>
          </h1>
          <p className="hero-subtitle">
            my SKKU는 성균관대 학생들을 위한<br />
            통합 라이프스타일 플랫폼입니다.
          </p>
        </div>
        
        <div className="services-grid">
          {/* Active Service Card */}
          <a href={noticeUrl} className="service-card active">
            <div className="card-icon">📢</div>
            <div className="card-content">
              <h3>Notice</h3>
              <p>학교, 단과대, 학과 공지사항을<br />한곳에서 모아보세요.</p>
              <span className="service-status">이용 가능 &rarr;</span>
            </div>
          </a>

          {/* Future Service Placeholder 1 */}
          {/* <div className="service-card coming-soon">
            <div className="card-icon">🗓️</div>
            <div className="card-content">
              <h3>Schedule</h3>
              <p>학사 일정과 시간표를<br />스마트하게 관리하세요.</p>
              <span className="service-status">준비 중</span>
            </div>
          </div> */}

          {/* Future Service Placeholder 2 */}
          <div className="service-card coming-soon">
            <div className="card-icon">🍽️</div>
            <div className="card-content">
              <h3>Cafeteria</h3>
              <p>오늘의 학식 메뉴와<br />운영 시간을 확인하세요.</p>
              <span className="service-status">준비 중</span>
            </div>
          </div>
        </div>
      </main>
      
      <footer className="main-footer">
        <p>&copy; {new Date().getFullYear()} my SKKU. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default MainPage;